module.exports = __webpack_public_path__ + "static/media/machine-empty.1b2567aa.svg";